import { useQuery as s } from "@tanstack/react-query";
import { isArrayWithItems as i } from "../../../helpers/array-helper.js";
import { postTrailerAvailabilityRequest as l } from "../requests/postTrailerAvailability.js";
const a = ({ from: e, to: r, locationIds: t }) => {
  const o = i(t) ? t?.map((n) => n.toString()) : "";
  return `${e}${r}${o}`;
}, m = (e) => {
  const r = a(e);
  return s({
    queryKey: ["trailer-availability", r],
    queryFn: async () => {
      const t = e.locationIds;
      return !e.from || !e.to || !i(t) ? Promise.resolve(null) : await l(e.from, e.to, t || []);
    },
    enabled: !1,
    retry: !0,
    staleTime: 6e5
  });
};
export {
  m as useGetTrailerAvailability
};
